// extracted by mini-css-extract-plugin
module.exports = {"info":"#3298dc","danger":"#f14668","success":"#48c774"};